import React, { useEffect } from "react"
import {
  Grid,
  ListItem,
  TextField,
  List,
  ListItemText,
  Collapse,
  IconButton,
  Chip,
  Button
} from "@mui/material/"
import {
  SEARCH_ICON,
  FILTER_ICON
} from "../assets/icons/IconList"

import {DataCatalogCard} from "../components/cards"
import axios from "axios"
import DummyData from "../data/model_card.json"

export default function DataCatalog() {

  useEffect(() => {
    getDataCatalogList()
  }, [])
  const BASE_URL = process.env.REACT_APP_BASE_URL
  const [dataFiles, setDataFiles] = React.useState([])

  const getDataCatalogList = () => {

      let data = JSON.stringify({
        "limit" : 50,
        "next": "54b834c7-f678-4c53-87a1-98bc06c1940a"
      })

      let config = {
        method: 'post',
        url: `${BASE_URL}/record/list`,
        headers: { 
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.rs1-a0IbdNh4p73jLHQ6xVFUBn2Xn2CLJHA0fbGQ6ko', 
          'Content-Type': 'application/json'
        },
        data: data
      }

      axios.request(config)
      .then(function (response) {
        console.log(response.data.Items)
        setDataFiles(response.data.Items)

      })
      .catch(function (error) {
        console.log(error);
      })

    }
 

  return (
   
    <div style={{height: '100%'}} >

      <Grid container xs={11}  >
        <Grid item xs={12}  >
          <List style={{paddingLeft: '25px', marginTop: '10px'}} >
            <ListItem>
          
              <ListItemText
                primary={<div className="pageTitle" >Data Catalog</div>}
              />
            </ListItem>
          </List>
          </Grid>
        </Grid>

      <Grid container xs={11}  className="dataCatalogContainer" >

        <Grid container xs={12} spacing={3} >

            <Grid item xs={2}  >
           <div className="spacer20" />
                <Button
                  href={"/dataUpload"}
                  style={{background: '#3f58c6', color: '#fff', padding: '20px'}}
                >
                  Upload Dataset

                </Button>
              
              <div className="spacer30" />
           
              <Button
                  href={"/"}
                  style={{background: '#3f58c6', color: '#fff', padding: '20px'}}
                >
                  Link to Dataset

                </Button>
            
            </Grid>

            <Grid item xs={10}  >
              <Grid item xs={12}  >
              <Grid
              container
              xs={12}
              className="searchBox"
            >
              
              <Grid item xs={1} style={{margin: '10px 0 0 0',paddingLeft: '5px'}} >
                <SEARCH_ICON color={"#999"}   />
              </Grid>
              <Grid item xs={10} >
            
                <TextField
                  className="input"
                  sx={{
                    "& fieldset": { border: "none" },
                    width: "75%",
                  }}
                  autoFocus
                  placeholder={"Search Catalog "}
                  name="questionSearch"
                />
              </Grid>

              <Grid item xs={1} style={{marginTop: '3px'}}>
                <IconButton
                  type="submit"
                  id="searchBtn"
                  variant="contained"
                  className="searchButton"
                >
                  <FILTER_ICON
                    color={"#aafbf2"}
                  />
                </IconButton>
            
                 </Grid>
              </Grid>

                <div className="spacer20" />

                <Grid item xs={12} style={{paddingLeft: '10px'}} >
                  <Chip label="CPG" style={{background: '#858fed'}} />
                  &nbsp;&nbsp;
                  <Chip label="Strategy" variant="outlined" style={{border: '1px solid #858fed', color: '#858fed'}} />
                  &nbsp;&nbsp;
                  <Chip label="News" variant="outlined" style={{border: '1px solid #858fed', color: '#858fed'}} />
                  &nbsp;&nbsp;
                  <Chip label="Data" variant="outlined" style={{border: '1px solid #858fed', color: '#858fed'}} />
                  &nbsp;&nbsp;
                  <Chip label="Advana" variant="outlined" style={{border: '1px solid #858fed', color: '#858fed'}} />
                </Grid>


              </Grid>
              <div className="spacer20" />
              <div className="divider" />
              <div className="spacer30" />
              <Grid container xs={12} spacing={2}  >
     
                {
                  dataFiles.map((item)=>{
                
                  return <Grid item xs={6}  >
                  
                           <DataCatalogCard 
                                  date={item.createdAt}
                                  updatedDate={item.updatedAt}
                                  requestedBy={item.requestedBy}
                                  source={item.meta}
                                  name={item.meta}
                                  owner={item.meta}
                                  desc={item.meta}
                                  email={"JohnDoe@example.com"}
                                  team={"Data Analytics"}
                                  type={"ADHOC"}
                                  file={"/sample/sample_file.xlsx"}
                                  color={"#333"}
                                  backgroundColor={"#d4fffa"}
                                />
                   
                  
                  </Grid>
                     })
                    }

      

                
              </Grid>
            </Grid>

        </Grid>

        
      </Grid>
    </div>

  )
}
